export default __webpack_public_path__ + "static/media/Asset 12.0bc3d9d2.png";